export enum PoleIssueQuestionValue {
	BrokenGuyWire = 'Broken guy wire',

	Broken = 'Broken / fallen',
	DangerFalling = 'In danger of falling',

	Leaning = 'Leaning',

	// TODO: this is used in street light / OPL flows -- should those map to the other values?
	Damaged = 'Damaged',

	// TODO: this is used in GLN flows
	Rotted = 'Rotted',
}
